module.exports = __webpack_public_path__ + "static/media/question.18153894.svg";